import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Heart, MessageCircle } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface DiscussionCardProps {
  discussion: any;
  onClick: (discussion: any) => void;
  getVoteCount?: (itemId: string, baseCount: number) => number;
}

const DiscussionCard: React.FC<DiscussionCardProps> = ({ discussion, onClick, getVoteCount }) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div 
      className="group cursor-pointer transition-all duration-300 hover:scale-105"
      onClick={() => onClick(discussion)}
    >
      <div className="p-4 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 group-hover:bg-white/10 group-hover:border-[#0FFF55]/30 group-hover:shadow-[0_0_15px_rgba(15,255,85,0.2)] transition-all duration-300">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <Avatar className="w-8 h-8 ring-1 ring-[#0FFF55]/50 transition-all duration-300 group-hover:ring-2 group-hover:ring-[#0FFF55] group-hover:scale-110">
              <AvatarImage src={discussion.author?.avatar_url} />
              <AvatarFallback className="bg-gradient-to-br from-[#0FFF55] to-[#0dd149] text-[#121316] text-xs font-semibold">
                {getInitials(discussion.author?.full_name || 'U')}
              </AvatarFallback>
            </Avatar>
          </div>
          
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-white group-hover:text-[#0FFF55] transition-colors duration-300 line-clamp-2">
              {discussion.title}
            </h4>
            <div className="flex items-center gap-4 mt-2 text-xs text-gray-400">
              <span className="flex items-center gap-1 transition-colors duration-300 group-hover:text-[#0FFF55]">
                <Heart className="w-3 h-3" />
                {getVoteCount ? getVoteCount(discussion.id, discussion.votes_count || 0) : (discussion.votes_count || 0)}
              </span>
              <span className="flex items-center gap-1 transition-colors duration-300 group-hover:text-[#0FFF55]">
                <MessageCircle className="w-3 h-3" />
                {discussion.replies_count || 0}
              </span>
              <span className="transition-colors duration-300 group-hover:text-gray-300">
                {discussion.created_at && formatDistanceToNow(new Date(discussion.created_at), {
                  addSuffix: true,
                  locale: ptBR
                })}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscussionCard; 